import { useEffect, useState } from 'react';

/*
 * usePsv2Dark — whether the surrounding .psv2 shell is in dark mode.
 * Watches the shell's class list so third-party islands that take a
 * color-mode prop (e.g. CodeEditor's data-color-mode) follow the
 * account-menu toggle live instead of being hard-coded light.
 */
export default function usePsv2Dark(): boolean {
    const [dark, setDark] = useState(
        () => localStorage.getItem('psv2-dark') === '1',
    );

    useEffect(() => {
        const root = document.querySelector('.psv2');
        if (!root) return;
        const sync = () => setDark(root.classList.contains('dark'));
        sync();
        const observer = new MutationObserver(sync);
        observer.observe(root, {
            attributes: true,
            attributeFilter: ['class'],
        });
        return () => observer.disconnect();
    }, []);

    return dark;
}
